import { ORDER_STATUS } from '@/schemas/order';

export interface IApi {
  url: string;
  method?: string;
}

export interface IResponse {
  code: string;
  data?: any;
}

export interface IItemTab {
  title: string; // 标题
  iconClassName: string; // 图标类名,带icon-前缀
  link?: string; // 跳转链接
}

export interface IQueryOrParamsProps {
  [key: string]: string;
}

export enum GENDER {
  Female,
  Male
}

// 是谁拉起IM聊天
export enum IM_TYPE {
  User, // 患者和医生聊
  Doctor, // 医生点击接诊开始和患者聊
  CustomerService // 用户点击客服
}

export interface UNREAD_INFO {
  pollingFrequency: number; // 轮询频率,返回整数表示每隔n毫秒轮询一次,返回inf时停止轮询
  unreadCount: number; // 未读消息数
}

// 查询未读消息时是按医生查还是按患者查
export enum UNREAD_TYPE {
  User, // 0
  Doctor // 1
}

export enum TYPE_SWITCH {
  WORKSTATION,
  CHANNEL
}

export interface IUnreadIMInfo {
  doctorAvatar: string;
  doctorName: string;
  merchantId: number;
  orderStatus: number;
  doctorId: number;
  productType: number;
  freeReply: string; // 赠送回复次数：-1不可赠送，0可赠送，1已赠送
  orderId: number;
  createTime: string;
  finishTime: string;
}

export interface IHomeUnreadMessage {
  doctorCount: number;
  doctorImInfoVo: IUnreadIMInfo;
  unreadCount: number;
  unreadRemindText: string;
  orderIds: number[];
}

export interface IYodaSelectedImage {
  base64: string;
  fileType: string;
  height: number;
  originFilePath: string;
  width: number;
}

export interface IPageList<list> {
  lastMark: boolean;
  list: list;
  pageNum: number;
  pageSize: number;
}

// 埋点用户角色
export enum ENUM_ROLE {
  PRESCRIPTION = 'PRESCRIPTION',
  PATIENT = 'PATIENT',
  DOCTOR = 'DOCTOR'
}

// 埋点按钮类型枚举值
export enum ENUM_BUTTON_NAME {
  CONFIRM = 'CONFIRM',
  EDIT = 'EDIT',
  CONTINUE = 'CONTINUE',
  COMMUNICATE = 'COMMUNICATE',
  SUBMIT = 'SUBMIT',
  DELETE = 'DELETE',
  EVALUATE = 'EVALUATE',
  ANSWER = 'ANSWER',
  CONSULT_AGAIN = 'CONSULT_AGAIN',
  TO_PAY = 'TO_PAY',
  VIEW_MESSAGE = 'VIEW_MESSAGE',
  DETAIL = 'DETAIL',
  PRESCRIBING = 'PRESCRIBING', // 开处方
  PRESCRIPTION = 'PRESCRIPTION', // 查看处方
  CARD = 'CARD',
  CANCEL = 'CANCEL',
  CONTACT = 'CONTACT',
  REJECT = 'REJECT',
  PRESENT = 'PRESENT' // 赠次数
}

// 埋点点击事件类型枚举值
export enum ENUM_CLICK_TYPE {
  BOTTOM_FUNCTION_BUTTON = 'BOTTOM_FUNCTION_BUTTON',
  INTELLIGENT_RESULT_POPUP = 'INTELLIGENT_RESULT_POPUP',
  ORDER_CARD = 'ORDER_CARD',
  SWITCH_TAB = 'SWITCH_TAB',
  SWITCH_SECOND_TAB = 'SWITCH_SECOND_TAB',
  SEND_BUTTON = 'SEND_BUTTON',
  SELECT_BUTTON = 'SELECT_BUTTON'
}

export const FLOAT_WINDOW_DATA = 'FLOAT_WINDOW_DATA';

// 添加页面到浮窗时url上增加该参数用来标明访问的页面是否从弹窗打开
export const URL_SOURCE = {
  key: 'urlSource',
  value: 'floatWindow'
};
export enum FLOAT_WINDOW_CARD_TYPE {
  PRESCRIBE = '开处方',
  SUMMARY = '咨询小结'
}

// 保存预开方修改时间,用于给消息列表排序
export const PRESCRIPTION_ORDER_ID_TIME_LIST =
  'PRESCRIPTION_ORDER_ID_TIME_LIST';

export interface IFloatDataItem {
  cardType: number;
  orderId: string;
  url: string;
  patientInfo: {
    age: string;
    name: string;
    sex: string;
    symptom: string;
  };
}

//  是否创建默认快捷回复，0-未创建，1-已创建
export enum QUICK_REPLY {
  UNCREATE,
  CREATED
}
